import React from 'react'
import Flag from '../components/Flag'
import classes from './CurrentLocale.module.scss'
import IconCheckmark from '@veneer/core/dist/esm/scripts/icons/icon_checkmark'

const CurrentLocale = ({ country, name, showFlag = true }) => {
  return (
    <div
      className={classes.currentLanguageSelected}
      data-testid="current-language"
    >
      {showFlag && country && <Flag country={country} size={24} />}
      <p className={classes.countryName}>{name}</p>
      <IconCheckmark className={classes.checkmark} size={18} />
    </div>
  )
}

export default CurrentLocale
